const addKeyPressEventListener = require('../helpers/addkeypresseventlistener');
const events = require('../core/events');
const forgeUiComponent = require('../framework/ui-component');


const Modal = forgeUiComponent('Modal', {}, function ModalConstructor() {
  const self = this;
  const content = self.element.querySelector('.Modal-content') || document.createElement('div');

  function dispatchDismiss() {
    self.element.dispatchEvent(new CustomEvent(events.uiModalDismiss, {
      bubbles: true
    }));
  }

  this.element.addEventListener('click', function (e) {
    if (content === e.target || content.contains(e.target)) {
      return;
    }
    e.stopPropagation();
    e.preventDefault();
    dispatchDismiss();
  });

  addKeyPressEventListener(window, 27, function () { // ESC key
    dispatchDismiss();
  });

  document.addEventListener(events.navigationRequestEnded, function dismissAfterNavigate() {
    dispatchDismiss();
  });
});

module.exports = Modal;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/modal.js
// module id = 68
// module chunks = 0